export default __webpack_public_path__ + "static/media/dp-big--portfolio-07.905218e2.jpg";